<template>
  <modal
    transition="nice-modal-fade"
    width="680"
    :adaptive="true"
    :reset="true"
    height="auto"
    :name="modalName"
    class="listing--form-modal action--modal"
    @opened="opened"
    @before-open="beforeOpen"
  >
    <div class="modal--wrapper">
      <section-loading :show="loading" />
      <button type="button" class="close" @click="close">
        <img src="@/assets/img/icons/close-1.svg" />
      </button>
      <section class="modal--container">
        <div class="subtitle--text">
          {{ $t('listing.modal.transferCoin.title') }}
        </div>
        <div class="coin--transfer-available">
          {{ `${$t('listing.modal.transferCoin.available')}: ${availableAmount}` }}
        </div>
        <div class="d-flex justify-center">
          <div class="mt-4 mb-4" style="width: 360px">
            <div
              class="single--field py-0"
              :class="validation.hasError('email') ? 'has-error' : ''"
            >
              <v-text-field
                :label="$t('listing.modal.transferCoin.email')"
                outlined
                :hide-details="true"
                type="email"
                v-model="email"
                name="email"
                :class="validation.hasError('email') ? 'is-invalid' : ''"
                class="basic--input input--margin"
              />
              <span class="val-error" v-if="validation.hasError('email')">{{
                validation.firstError('email')
              }}</span>
            </div>
            <div
              class="single--field py-0 mt-4"
              :class="validation.hasError('amount') ? 'has-error' : ''"
            >
              <v-text-field
                :label="$t('listing.modal.transferCoin.amount')"
                outlined
                :hide-details="true"
                type="number"
                v-model="amount"
                name="amount"
                :class="validation.hasError('amount') ? 'is-invalid' : ''"
                class="basic--input input--margin"
              />
              <span class="val-error" v-if="validation.hasError('amount')">{{
                validation.firstError('amount')
              }}</span>
            </div>
            <div
              class="single--field py-0 mt-4"
              :class="validation.hasError('notes') ? 'has-error' : ''"
            >
              <v-textarea
                :label="$t('listing.modal.transferCoin.notes')"
                outlined
                :hide-details="true"
                type="notes"
                v-model="notes"
                name="notes"
                :class="validation.hasError('notes') ? 'is-invalid' : ''"
                class="basic--input input--margin"
                rows="3"
              />
              <span class="val-error" v-if="validation.hasError('notes')">{{
                validation.firstError('notes')
              }}</span>
            </div>
          </div>
        </div>
        <div class="bottom--part">
          <a class="btn btn-primary" @click="transferCoin">
            <v-icon style="margin-right: 4px">mdi-swap-horizontal</v-icon>
            <span>{{ $t('listing.modal.transferCoin.btn') }}</span>
          </a>
        </div>
      </section>
    </div>
  </modal>
</template>

<script>
import { Validator } from 'simple-vue-validator';
import { mapState } from 'vuex';
const SectionLoading = () => import('@/components/content-loading/section-loading');

export default {
  name: 'transfer-coin-modal',
  components: {
    SectionLoading,
  },
  computed: {
    ...mapState({
      loading: (state) => state.coins.loading,
    }),
  },
  data() {
    return {
      modalName: 'transfer-coin-modal',
      submitAction: null,
      userCoinUuid: null,
      availableAmount: 0,
      email: null,
      amount: null,
      notes: null,
    };
  },
  validators: {
    email(value) {
      return Validator.value(value)
        .required(this.$i18n.t('errors.email.required'))
        .email(this.$i18n.t('errors.loginRegister.email.invalid'));
    },
    amount(value) {
      return Validator.value(value)
        .required(this.$i18n.t('errors.amount.required'))
        .custom(() => {
          if (value < 10) {
            return this.$i18n.t('errors.amount.min', { min: 10 });
          }
          if (value > this.availableAmount) {
            return this.$i18n.t('errors.amount.max');
          }
        });
    },
    notes(value) {
      return Validator.value(value).maxLength(
        160,
        this.$i18n.t('errors.notes.max', { maxChar: 160 }),
      );
    },
  },
  methods: {
    close() {
      this.$modal.hide(this.modalName);
    },
    async beforeOpen(event) {
      this.email = null;
      this.amount = null;
      this.notes = null;
      if (event.params && event.params.submitAction !== null) {
        this.submitAction = event.params.submitAction;
      }
      if (event.params && event.params.userCoinUuid !== null) {
        this.userCoinUuid = event.params.userCoinUuid;
      }
      if (event.params && event.params.availableAmount !== null) {
        this.availableAmount = event.params.availableAmount;
      }
    },
    async opened() {},
    async transferCoin() {
      const isValid = await this.$validate();
      if (isValid) {
        try {
          const result = await this.$swal({
            title: this.$i18n.t('listing.modal.transferCoin.title'),
            text: this.$i18n.t('listing.modal.transferCoin.confirm'),
            type: 'question',
            showCancelButton: true,
            confirmButtonText: this.$i18n.t('general.yes'),
            cancelButtonText: this.$i18n.t('general.cancel'),
            allowOutsideClick: false,
          });
          if (result.value) {
            const success = await this.$store.dispatch('coins/transferCoin', {
              userCoinUuid: this.userCoinUuid,
              email: this.email,
              amount: this.amount,
              notes: this.notes,
            });
            if (success) {
              this.$emit('submit');
              await this.$swal(
                this.$i18n.t('general.success'),
                this.$i18n.t('listing.modal.transferCoin.success'),
                'success',
              );
              if (this.submitAction !== null) {
                this.submitAction();
              }
              this.close();
            }
          }
        } catch (e) {
          console.log('ERROR TRANSFER KOIN: ', e);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/utils/variables';
.coin--transfer-available {
  font-family: Poppins-SemiBold, sans-serif;
  font-size: $font-lg;
}
</style>
